function PersonalizeUtil() {

	/**
	 * Toggle to disable the event tracker.
	 * This is independent of serving recommendations
	 * May be nice to turn off if Amazon Kinesis dies again...
	 */
	var ENABLE_TRACKER = true;

	function getBaseUrl() {
		return window.location.protocol + '//' + window.location.host + '/api';
	}

	/**
	 * Should attempt to send tracker events?
	 * @return {bool} If logged in user & tracker enabled
	 */
	function shouldSend() {
		if (!ENABLE_TRACKER || !window.cj) return false;

		if (window.cj.user && window.cj.user.id) {
			return true;
		}

		else if (window.cj.app_data && window.cj.app_data.user && window.cj.app_data.user.id) {
			return true;
		}

		return false;
	}

	// Send event to the AWS Personalize Event Tracker
	// The eventName should be a key in the personalize_lib.event_map
	function sendEvent(eventName, listingId) {
		return new Promise(function(resolve, reject) {
			if (!shouldSend()) {
				// quick bail if not logged in
				console.debug("Personalize event tracker skipped for anon visitor:", eventName, listingId);
				return resolve(true);
			}

			var url = getBaseUrl() + '/personalize/events/';
			var body = {
				item_id: listingId,
				event_type: eventName
			};
			var options = {
				method: 'POST',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json'
				},
				credentials: 'include',
				compress: false,
				body: JSON.stringify(body)
			};

			console.debug("Personalize event tracker hit", body);
			fetch(url, options)
				.then(function(res) { return res.json(); })
				.then(function(res) {
					// Resolve quietly
					// Assume it worked, if it didn't ... oh well
					resolve(true);
				})
				// Dont throw here — just reject
				// Caller should be able to catch & handle as they see fit
				.catch(reject);
		});
	}

	return {
		sendEvent: sendEvent
	};
}

// Export for requirejs & reactjs ...
// If checkout is ever converted, we could just use ApiRequest here
if (typeof require === 'function' && typeof exports !== 'undefined') {
	module.exports = PersonalizeUtil();
} else {
	define([], PersonalizeUtil);
}
